import React from 'react';
import { db } from '../../utils/firebase';
import TableComponent from '../../components/TableComponent';
import SearchDialog from '../../components/SearchDialog';
import QuestionSet from '../../components/Questions/QuestionSet';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import _ from 'lodash';
import QuestionContext from '../../QuestionContext';

class AllQuestionSets extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            question_sets: [],
            setData: null,
            qsetModal: false,
            newQsetModal: false,
            openQuestionSearch: false,
            openSnackbar: false,
            snackbarMessage: '',
            page: 0,
            rowsPerPage: 10,
        };
        this.updateState = this.updateState.bind(this);
        this.updateSetData = this.updateSetData.bind(this);
        this.removeQuestionFromSet = this.removeQuestionFromSet.bind(this);
        this.toggleQuestionSearch = this.toggleQuestionSearch.bind(this);
        this.addQuestionToSet = this.addQuestionToSet.bind(this);
        this.toggleNewQuestionSet = this.toggleNewQuestionSet.bind(this);
        this.addNewSet = this.addNewSet.bind(this);
        this.updateSet = this.updateSet.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
    }

    componentDidMount() {
        db.collection("question_sets").onSnapshot(querySnapshot => {
            const question_sets = querySnapshot.docs.map(doc => doc.data());
            this.setState({
                question_sets: question_sets
            });
        });
    }

    updateState(value, state) {
        this.setState({
            [state]: value
        });
    }

    updateSetData(value, path) {
        let dataCopy = { ...this.state.setData };
        _.set(dataCopy, path, value);
        this.setState({
            setData: dataCopy
        });
    }

    removeQuestionFromSet(idx) {
        let dataCopy = { ...this.state.setData };
        dataCopy.fields.splice(idx, 1);
        this.setState({
            setData: dataCopy
        });
    }

    addQuestionToSet(data) {
        console.log(data);
        let dataCopy = { ...this.state.setData };
        dataCopy.fields.push(data.ref);
        this.setState({
            setData: dataCopy,
            openQuestionSearch: false
        });
    }

    toggleNewQuestionSet(){
        this.setState({
            newQsetModal: true,
            setData: {
                id: '',
                description: '',
                fields: [],
            }
        })
    }

    addNewSet() {
        console.log("Adding new set...", this.state.setData);
        let setRef = db.collection('question_sets').doc(this.state.setData.id);
        setRef.get().then(set => {
            if(set.exists){
                this.setState({
                    openSnackbar: true,
                    snackbarMessage: `Question Set with id "${this.state.setData.id}" already exists.`,
                });
            }else{
                db.collection('question_sets').doc(this.state.setData.id).set({...this.state.setData, dateAdded: new Date()}).then(() => {
                    console.log(`Question ${this.state.setData.id} was successfully added.`)
                    this.setState({
                        openSnackbar: true,
                        snackbarMessage: `Question Set ${this.state.setData.id} was successfully added.`,
                        newQsetModal: false,
                        setData: null
                    });
                }).catch(err => {
                    console.log(`Error updating question set: ${err}`);
                });
            }
        })
    }

    updateSet() {
        console.log("Saving set...", this.state.setData);
        db.collection('question_sets').doc(this.state.setData.id).set(this.state.setData).then(() => {
            console.log(`Question ${this.state.setData.id} was successfully edited.`)
            this.setState({
                openSnackbar: true,
                snackbarMessage: `Question Set ${this.state.setData.id} was successfully edited.`,
                qsetModal: false,
                setData: null
            });
        }).catch(err => {
            console.log(`Error updating question set: ${err}`);
        })
    }

    toggleQuestionSearch() {
        this.setState({
            openQuestionSearch: !this.state.openQuestionSearch
        })
    }

    onRowClick(data) {
        console.log(data);
        let deepCloneData = _.cloneDeep(data);
        this.setState({
            qsetModal: true,
            setData: deepCloneData
        });
    }

    render() {
        return (
            <div style={{ textAlign: 'center', padding: 10, position: 'relative' }}>
                <h2> Question Sets </h2>
                <Button onClick={this.toggleNewQuestionSet} style={{ position: 'absolute', right: 30, top: 10, width: 200 }} variant="outlined" color="primary"> New QUESTION SET </Button>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ width: '95%' }}>
                        <TableComponent
                            data={this.state.question_sets}
                            headers={["ID", "Description", "Fields", "Date added"]}
                            fields={["id", "description", "fields", "dateAdded"]}
                            updateState={this.updateState}
                            onRowClick={this.onRowClick}
                            rowsPerPage={this.state.rowsPerPage}
                            page={this.state.page}
                            count={this.state.question_sets.length}
                        />
                    </div>
                </div>
                <Dialog
                    open={this.state.qsetModal}
                    onClose={() => this.updateState(!this.state.qsetModal, "qsetModal")}
                    fullWidth={true}
                    maxWidth={"md"}
                    aria-labelledby="set-dialog-title"
                >
                    <DialogTitle id="set-dialog-title">Question Set View</DialogTitle>
                    <DialogContent>
                        <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', width: '100%' }}>
                            {this.state.setData &&
                                <div style={{ width: '99%' }}>
                                    <QuestionSet
                                        data={this.state.setData}
                                        removeQuestionFromSet={this.removeQuestionFromSet}
                                        updateSetData={this.updateSetData}
                                        toggleQuestionSearch={this.toggleQuestionSearch}
                                        newSet={false}
                                    />
                                </div>
                            }
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => this.updateState(!this.state.qsetModal, "qsetModal")}>Close</Button>
                        <Button variant="outlined" onClick={this.updateSet}>Save Set</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.newQsetModal}
                    onClose={() => this.updateState(!this.state.newQsetModal, "qsetModal")}
                    fullWidth={true}
                    maxWidth={"md"}
                    aria-labelledby="set-dialog-title"
                >
                    <DialogTitle id="set-dialog-title">New Question Set</DialogTitle>
                    <DialogContent>
                        <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', width: '100%' }}>
                            {this.state.setData &&
                                <div style={{ width: '99%' }}>
                                    <QuestionSet
                                        data={this.state.setData}
                                        removeQuestionFromSet={this.removeQuestionFromSet}
                                        updateSetData={this.updateSetData}
                                        toggleQuestionSearch={this.toggleQuestionSearch}
                                        newSet={true}
                                    />
                                </div>
                            }
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => this.updateState(!this.state.newQsetModal, "newQsetModal")}>Close</Button>
                        <Button variant="outlined" onClick={this.addNewSet}>Save Set</Button>
                    </DialogActions>
                </Dialog>
                {this.context.length > 0 &&
                    <SearchDialog
                        data={this.context}
                        open={this.state.openQuestionSearch}
                        toggleOpen={this.toggleQuestionSearch}
                        onRowClick={this.addQuestionToSet}
                    />
                }
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={this.state.openSnackbar}
                    autoHideDuration={5000}
                    onClose={() => this.updateState(false, "openSnackbar")}
                    message={this.state.snackbarMessage}
                    action={
                        <IconButton size="small" aria-label="close" color="inherit" onClick={() => this.updateState(false, "openSnackbar")}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    }
                    style={{ fontSize: 14 }}
                />
            </div>
        )
    }
}

AllQuestionSets.contextType = QuestionContext;

export default AllQuestionSets;